import { toggleEmbedCardCreateModal } from '@blocksuite/hive-components/embed-card-modal';
import type { SlashMenuConfig } from '@blocksuite/hive-widget-slash-menu';
import { LoomLogoDuotoneIcon } from '@blocksuite/icons/lit';

import { LoomTooltip } from './tooltips';

export const embedLoomSlashMenuConfig: SlashMenuConfig = {
  items: [
    {
      name: 'Loom',
      icon: LoomLogoDuotoneIcon(),
      description: 'Embed a Loom video.',
      tooltip: {
        figure: LoomTooltip,
        caption: 'loom',
      },
      group: '4_Content & Media@9',
      when: ({ model }) =>
        model.doc.schema.flavourSchemaMap.has('hive:embed-loom'),
      action: ({ std, model }) => {
        (async () => {
          const { host } = std;
          const parentModel = host.doc.getParent(model);
          if (!parentModel) {
            return;
          }
          const index = parentModel.children.indexOf(model) + 1;
          await toggleEmbedCardCreateModal(
            host,
            'Loom',
            'The added Loom video link will be displayed as an embed view.',
            { mode: 'page', parentModel, index }
          );
          if (model.text?.length === 0) std.store.deleteBlock(model);
        })().catch(console.error);
      },
    },
  ],
};
